import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const ANNOUNCEMENT_PERMISSIONS = {
  WRITE: PERMISSIONS.ANNOUNCE_WRITE,
};

export const ANNOUNCEMENT_QUERY_KEYS = queryKeys.announcements;

export const ANNOUNCEMENT_AUDIENCE = {
  ALL: 'ALL',
  BUYER: 'BUYER',
  SUPPLIER: 'SUPPLIER',
};
